import { useSoftDeployAccess } from 'App/components/hooks';

export default function () {
	return useSoftDeployAccess('TODO_LIST');
}
